const PREFIX = '@integration_event/'

export const INTEGRATION_LIBRARY_EVENT = {
    LOADED: `${PREFIX}loaded`,
    CLOSE: `${PREFIX}close`,
    REDIRECT: `${PREFIX}redirect`,
};
